
/*
 *   File : investment-summary.js
 *   Author : https://evoqins.com
 *   Description : Card to show investment summary
 *   Integrations : null
 *   Version : 1.0.0
 */

import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from "react-router";
import { Modal } from 'bootstrap';

import { OutlineButton, GradientButton } from '../CTA';
import { Toggle } from '../Form-elements';
import Icon from '../Icon/icon';
import { DoughnutChart } from "../Chart";

import style from '../../Styles/Component/investment-summary.module.scss';
import { InviteMemberModal } from '../Modal';

const TOTAL_RETURNS_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className='position-absolute top--3 right--3'>
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#84DCC8" />
        <path d="M15 10.127L14.7009 11.1465H9L9.29912 10.127H15ZM12.3255 17L9.10557 13.0625L9.08798 12.3242H10.6891C11.1056 12.3242 11.4604 12.2656 11.7537 12.1484C12.0469 12.0283 12.2713 11.8496 12.4267 11.6123C12.5821 11.3721 12.6598 11.0703 12.6598 10.707C12.6598 10.1709 12.4985 9.75049 12.176 9.4458C11.8534 9.13818 11.3578 8.98437 10.6891 8.98437H9L9.29912 8H10.6891C11.4047 8 11.9912 8.11865 12.4487 8.35596C12.9091 8.59033 13.2493 8.9126 13.4692 9.32275C13.6921 9.72998 13.8035 10.1914 13.8035 10.707C13.8035 11.1729 13.7009 11.6021 13.4956 11.9946C13.2933 12.3843 12.9677 12.6978 12.5191 12.9351C12.0733 13.1724 11.4839 13.291 10.7507 13.291H10.7243L13.6979 16.9297V17H12.3255ZM15 8L14.7009 9.01953L10.2141 8.98437L10.5132 8H15Z" fill="#1177BD" />
        <path d="M20.2484 6.89961H17.8484C17.6024 6.89961 17.3984 6.69561 17.3984 6.44961V4.04961C17.3984 3.80361 17.6024 3.59961 17.8484 3.59961C18.0944 3.59961 18.2984 3.80361 18.2984 4.04961V5.99961H20.2484C20.4944 5.99961 20.6984 6.20361 20.6984 6.44961C20.6984 6.69561 20.4944 6.89961 20.2484 6.89961Z" fill="#1177BD" />
        <path d="M17.8469 6.8985C17.7329 6.8985 17.6189 6.8565 17.5289 6.7665C17.3549 6.5925 17.3549 6.3045 17.5289 6.1305L20.5289 3.1305C20.7029 2.9565 20.9909 2.9565 21.1649 3.1305C21.3389 3.3045 21.3389 3.5925 21.1649 3.7665L18.1649 6.7665C18.0749 6.8565 17.9609 6.8985 17.8469 6.8985Z" fill="#1177BD" />
    </svg>
);

const XIRR_ICON = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className='position-absolute top--3 right--3'>
        <path d="M9.59236 3.20031C9.34886 3.40782 9.2271 3.51158 9.09706 3.59874C8.79896 3.79854 8.46417 3.93721 8.1121 4.00672C7.95851 4.03705 7.79903 4.04977 7.48008 4.07522L7.48007 4.07523C6.67869 4.13918 6.278 4.17115 5.94371 4.28923C5.17051 4.56233 4.56233 5.17051 4.28923 5.94371C4.17115 6.278 4.13918 6.67869 4.07523 7.48007L4.07522 7.48008C4.04977 7.79903 4.03705 7.95851 4.00672 8.1121C3.93721 8.46417 3.79854 8.79896 3.59874 9.09706C3.51158 9.2271 3.40781 9.34887 3.20028 9.59239L3.20027 9.5924C2.67883 10.2043 2.4181 10.5102 2.26522 10.8301C1.91159 11.57 1.91159 12.43 2.26522 13.1699C2.41811 13.4898 2.67883 13.7957 3.20027 14.4076L3.20031 14.4076C3.4078 14.6511 3.51159 14.7729 3.59874 14.9029C3.79854 15.201 3.93721 15.5358 4.00672 15.8879C4.03705 16.0415 4.04977 16.201 4.07522 16.5199L4.07523 16.5199C4.13918 17.3213 4.17115 17.722 4.28923 18.0563C4.56233 18.8295 5.17051 19.4377 5.94371 19.7108C6.27799 19.8288 6.67867 19.8608 7.48 19.9248L7.48008 19.9248C7.79903 19.9502 7.95851 19.963 8.1121 19.9933C8.46417 20.0628 8.79896 20.2015 9.09706 20.4013C9.22711 20.4884 9.34887 20.5922 9.5924 20.7997C10.2043 21.3212 10.5102 21.5819 10.8301 21.7348C11.57 22.0884 12.43 22.0884 13.1699 21.7348C13.4898 21.5819 13.7957 21.3212 14.4076 20.7997C14.6511 20.5922 14.7729 20.4884 14.9029 20.4013C15.201 20.2015 15.5358 20.0628 15.8879 19.9933C16.0415 19.963 16.201 19.9502 16.5199 19.9248L16.52 19.9248C17.3213 19.8608 17.722 19.8288 18.0563 19.7108C18.8295 19.4377 19.4377 18.8295 19.7108 18.0563C19.8288 17.722 19.8608 17.3213 19.9248 16.52L19.9248 16.5199C19.9502 16.201 19.963 16.0415 19.9933 15.8879C20.0628 15.5358 20.2015 15.201 20.4013 14.9029C20.4884 14.7729 20.5922 14.6511 20.7997 14.4076C21.3212 13.7957 21.5819 13.4898 21.7348 13.1699C22.0884 12.43 22.0884 11.57 21.7348 10.8301C21.5819 10.5102 21.3212 10.2043 20.7997 9.5924C20.5922 9.34887 20.4884 9.22711 20.4013 9.09706C20.2015 8.79896 20.0628 8.46417 19.9933 8.1121C19.963 7.95851 19.9502 7.79903 19.9248 7.48008L19.9248 7.48C19.8608 6.67867 19.8288 6.27799 19.7108 5.94371C19.4377 5.17051 18.8295 4.56233 18.0563 4.28923C17.722 4.17115 17.3213 4.13918 16.5199 4.07523L16.5199 4.07522C16.201 4.04977 16.0415 4.03705 15.8879 4.00672C15.5358 3.93721 15.201 3.79854 14.9029 3.59874C14.7729 3.51158 14.6511 3.40781 14.4076 3.20027C13.7957 2.67883 13.4898 2.41811 13.1699 2.26522C12.43 1.91159 11.57 1.91159 10.8301 2.26522C10.5102 2.4181 10.2043 2.67883 9.5924 3.20027L9.59236 3.20031Z" fill="#84DCC8" />
        <path d="M15.8299 8.17001C16.1477 8.48785 16.1477 9.00315 15.8299 9.32099L9.31903 15.8319C9.0012 16.1497 8.48589 16.1497 8.16806 15.8319C7.85023 15.514 7.85023 14.9987 8.16806 14.6809L14.6789 8.17001C14.9968 7.85218 15.5121 7.85218 15.8299 8.17001Z" fill="#1177BD" />
        <path d="M15.797 14.7138C15.797 15.3131 15.3112 15.799 14.7119 15.799C14.1125 15.799 13.6267 15.3131 13.6267 14.7138C13.6267 14.1145 14.1125 13.6287 14.7119 13.6287C15.3112 13.6287 15.797 14.1145 15.797 14.7138Z" fill="#1177BD" />
        <path d="M9.28612 10.3732C9.88543 10.3732 10.3713 9.88738 10.3713 9.28807C10.3713 8.68876 9.88543 8.20293 9.28612 8.20293C8.68681 8.20293 8.20097 8.68876 8.20097 9.28807C8.20097 9.88738 8.68681 10.3732 9.28612 10.3732Z" fill="#1177BD" />
    </svg>
);

function InvestmentSummaryCard(props) {

    const navigate = useNavigate();

    const [showPortfolio, setShowPortfolio] = useState(null);
    const [showAllReturns, setShowAllReturns] = useState(true);
    const [portfolioData, setPortfolioData] = useState(props.data); //commented this to avoid  'setPortfolioData' is assigned a value but never used    
    const [showTooltip, setShowTooltip] = useState(false);
    const [showInviteModal, setShowInviteModal] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(()=> {
        function _handleResize() {
            setWindowWidth(windowWidth.innerWidth);
        }

        window.addEventListener('resize', _handleResize);

        return() => {
            window.removeEventListener('resize', _handleResize);
        }
    },[]);

    useEffect(() => {
        const stored_value = localStorage.getItem('show_portfolio_overview');

        if (stored_value !== null) {
            // Convert the stored string to a boolean
            setShowPortfolio(JSON.parse(stored_value));
        } else {
            localStorage.setItem('show_portfolio_overview', true);
            setShowPortfolio(true);
        }
    }, []);


    // listener for opening invite modal
    useEffect(() => {
        if (showInviteModal === true) {
            _openInviteModal();
        }
    }, [showInviteModal]);


    useEffect(() => {
        setPortfolioData(props.data);
    }, [props.data]);

    function _toggleSummaryMask() {
        localStorage.setItem('show_portfolio_overview', !showPortfolio)
        setShowPortfolio(!showPortfolio);
    }

    function _showTooltip() {
        setShowTooltip(true);
    }

    function _hideTooltip() {
        setShowTooltip(false);
    }

    function _navigateToPortfolio() {
        navigate("/portfolio");
    }

    //to open invite modal
    const _openInviteModal = () => {
        const modal = new Modal(document.getElementById("invite-modal"), {});
        modal.show();
    };


    const _showInviteModal = () => {
        setShowInviteModal(true);
    }

    const _handleInvite = (id, pan_number) => {
        setShowInviteModal(false);
        document.body.removeAttribute("style");
        var my_modal = document.getElementById("invite-modal");
        var modalBackdrop = document.querySelector(".modal-backdrop");
        my_modal.classList.remove("show");
        modalBackdrop.remove();
        my_modal.style.display = "none";
        console.log(id, pan_number);
    }

    // summary card component
    function SummaryCard(props) {
        return (
            <div className='bg-cards border-radius-16px p-3 h-100'>
                <div className='d-flex justify-content-between align-items-center flex-wrap'>
                    <p className='color-black e-poppins-medium e-font-14 mb-0'>{props.title}</p>
                    {props.icon}
                </div>
                {
                    showPortfolio === true ?
                        <p className='color-black e-poppins-semi-bold e-font-18-sm-14 line-height-20px margin-block-end-0 mt-3 position-relative'>
                            <span className={`e-inter-bold e-font-12-sm-14 align-top line-height-20px position-relative ${windowWidth >576 && 'top--3'}`}>₹</span>{props.value.toLocaleString('en-IN')}
                        </p>
                        :
                        <div className='mt-3 color-black e-poppins-semi-bold e-font-18 line-height-20px '>******</div>
                }
            </div>
        )
    };

    function TotalSummary() {
        return (
            Object.keys(portfolioData).length !== 0 &&
            <div className='bg-cards border-radius-16px p-3 mt-xl-4 '>
                <div className='row'>
                    {/* Total returns */}
                    <div className='col-sm-7 col-6 border-right-sm border-cool-gray'>
                        <div className='col-12'>
                            <div className='d-flex justify-content-between'>
                                <h6 className='color-black e-poppins-medium e-font-14'>Total returns</h6>
                                <div className='position-relative'>
                                    {TOTAL_RETURNS_ICON}
                                </div>
                            </div>
                            <div className="d-flex align-items-center gap-12px mb-2">
                                <span className={showAllReturns === true ? "e-poppins-medium e-font-12" : "color-old-silver e-poppins-regular e-font-12"}>
                                    All</span>
                                <Toggle check={showAllReturns}
                                    onChange={(e) => setShowAllReturns(e)} />
                                <span className={showAllReturns === false ? "e-poppins-medium e-font-12" : "color-old-silver e-poppins-regular e-font-12"}>1d</span>
                            </div>
                            {
                                showPortfolio === true ?
                                    <div className='d-flex align-items-center'>
                                        <span className='e-poppins-semi-bold e-font-18-sm-14 color-black position-relative'>
                                            <span className={`e-inter-bold e-font-14 position-relative ${windowWidth > 576 ? 'top--4' : 'top-0'} `}>₹</span>


                                            {
                                                showAllReturns === true ?
                                                    <span className={`${portfolioData.total_returns.all_returns >= 0 ? 'color-ufo-green' : 'color-red'} `}>
                                                        {portfolioData.total_returns.all_returns.toLocaleString('en-IN')}
                                                    </span>
                                                    :
                                                    <span className={`${portfolioData.total_returns.one_day_return >= 0 ? 'color-ufo-green' : 'color-red'} `}>
                                                        {portfolioData.total_returns.one_day_return.toLocaleString('en-IN')}
                                                    </span>
                                            }


                                        </span>
                                        {
                                            showAllReturns === true ?
                                                <>
                                                    {/* all return percentage */}
                                                    {
                                                        portfolioData.total_returns.all_returns_percentage == 0 ? // show '-' if return value is '0'
                                                            <span className={`e-poppins-regular e-font-16-sm-12 line-height-28px color-ufo-green ms-2`}>-</span>
                                                            :
                                                            <>
                                                                <div className={`${portfolioData.total_returns.all_returns_percentage >= 0 ? `${style.e_positive_indicator} e-fund-indicator-positive`  : `${style.e_negative_indicator} e-fund-indicator-negative`} mt-sm-0 mt-1 `}></div>
                                                                <span className={`e-poppins-regular e-font-16-sm-12  ${portfolioData.total_returns.all_returns_percentage >= 0 ? 'color-ufo-green' : 'color-red'}  `}>{portfolioData.total_returns.all_returns_percentage}%</span>
                                                            </>
                                                    }
                                                </>
                                                :
                                                <>
                                                    {/* 1D return percentage */}
                                                    {
                                                        portfolioData.total_returns.one_day_return_percentage == 0 ? // show '-' if return value is '0'
                                                            <span className={`e-poppins-regular e-font-16 line-height-28px color-ufo-green ms-2`}>-</span>
                                                            :
                                                            <>
                                                                <div className={`${portfolioData.total_returns.one_day_return_percentage >= 0 ? style.e_positive_indicator : style.e_negative_indicator}`}></div>
                                                                <span className={`e-poppins-regular e-font-16 ${portfolioData.total_returns.one_day_return_percentage >= 0 ? 'color-ufo-green' : 'color-red'}  `}>{portfolioData.total_returns.one_day_return_percentage}%</span>
                                                            </>
                                                    }
                                                </>
                                        }
                                    </div>
                                    :
                                    <div className=' color-black e-poppins-semi-bold e-font-18 margin-9px-top'>******</div>
                            }
                        </div>
                    </div>

                    {/* XIRR */}
                    <div className='col-sm-5 col-6 ps-sm-4'>
                        <div className='d-flex justify-content-between'>
                            <h6 className='mt-1 color-black e-poppins-medium e-font-14'>XIRR</h6>
                            <div className='position-relative'>
                                {XIRR_ICON}
                            </div>
                        </div>
                        {
                            showPortfolio === true ?
                                <h4 className={`e-poppins-semi-bold e-font-18-sm-14 mb-0 mt-4 ${portfolioData.xirr >= 0 ? 'color-ufo-green' : 'color-red'}  `}>{portfolioData.xirr}%</h4>
                                :
                                <div className=' color-black e-poppins-semi-bold e-font-18 line-height-20px mt-4'>******</div>
                        }
                    </div>
                </div>
            </div>
        )
    }

    return (
        <Fragment>
            <div className={`${style.e_card_wrapper} bg-portfolio-summary-card border-radius-24px p-sm-4 p-3 h-100`}>
                {/* card title section */}
                <div className='row'>
                    {/* title */}
                    <div className='col-sm-6 col-12'>
                        <div className='d-flex'>
                            <h4 className='color-black e-poppins-semi-bold e-font-16'>
                                Portfolio overview
                            </h4>
                            {
                                showPortfolio === false ?
                                    <div className='position-relative'
                                        onMouseEnter={_showTooltip}
                                        onMouseLeave={_hideTooltip}>
                                        <img src={require('../../Assets/Images/dashboard/eye-opend.svg').default}
                                            className='position-relative top--3 ms-1 cursor-pointer'
                                            onClick={_toggleSummaryMask}
                                            alt="" />
                                        {showTooltip === true &&
                                            <p className={`position-absolute border-radius-4px color-outer-space e-poppins-regular e-font-12 line-height-12px mb-0 z-index-1 bg-cards ${style.e_portfolio_tooltip}`}>
                                                Show portfolio
                                            </p>}
                                    </div>
                                    :
                                    <div className='position-relative'
                                        onMouseEnter={_showTooltip}
                                        onMouseLeave={_hideTooltip}>
                                        <img src={require('../../Assets/Images/dashboard/eye-slash.svg').default}
                                            className='position-relative top--3 ms-1 cursor-pointer'
                                            onClick={_toggleSummaryMask}
                                            alt="" />
                                        {
                                            showTooltip === true &&
                                            <p className={`position-absolute border-radius-4px color-outer-space e-poppins-regular e-font-12 line-height-12px mb-0 z-index-1 bg-cards ${style.e_portfolio_tooltip}`}>
                                                Hide portfolio
                                            </p>
                                        }
                                    </div>

                            }
                        </div>
                    </div>

                    {/* add family button */}
                    {
                        false &&
                        <div className='col-6 text-end'>
                            <OutlineButton label="Add family "
                                icon="add"
                                iconSize={24}
                                handleClick={_showInviteModal} />
                        </div>
                    }
                </div>

                {/* Content section */}
                <div className='row mt-3'>
                    {/* Summary section */}
                    <div className='col-xl-7 col-lg-12 col-md-12 col-12'>
                        {/* Invested & current value */}
                        <div className='row '>
                            <div className='col-6'>
                                <SummaryCard title="Invested"
                                    value={portfolioData.invested}
                                    icon={<Icon icon="invested-icon"
                                        size={24} />} />
                            </div>
                            <div className='col-6  ps-0'>
                                <SummaryCard title="Current value"
                                    value={portfolioData.current_val}
                                    icon={<Icon icon="suit-case"
                                        size={24} />} />
                            </div>
                            {/* Total summary */}
                            <div className='col-xl-12 col-lg-6 col-md-6 mt-2 pt-xl-1 pt-lg-0 pt-md-0 pt-1'>
                                <TotalSummary />
                            </div>
                        </div>

                        <GradientButton label="View your investment"
                            className="margin-30px-top  padding-8px-tb padding-16px-lr"
                            handleClick={_navigateToPortfolio} />
                    </div>

                    {/* Chart section */}
                    <div className='col-xl-5 col-lg-12 col-md-5 d-lg-block d-md-block d-none pt-xl-0 pt-lg-4'>
                        <div className='bg-portfolio-breakdown border-radius-16px p-3 position-relative h-95 example'>
                            <h6 className='color-black e-poppins-regular e-font-14'>Portfolio breakdown</h6>
                            {
                                portfolioData.breakdown.sip === 0 && portfolioData.breakdown.lumpsum === 0 ?
                                    <div className='h-90 d-flex align-items-center justify-content-center'>
                                        <div className='color-gray e-poppins-regular e-font-14 w-max-content  h-max-content'>
                                            No investment exists in your portfolio.
                                        </div>
                                    </div>
                                    :
                                    <DoughnutChart data={{
                                        labels: ['SIP', 'Lumpsum'],
                                        data: [portfolioData.breakdown.sip, portfolioData.breakdown.lumpsum],
                                        color: ['#64CFF6', '#756BFF']
                                    }}
                                        type={1} />
                            }

                        </div>
                    </div>
                </div>
            </div>
            {
                showInviteModal === true ?
                    <InviteMemberModal sendInvite={_handleInvite}
                        close={() => setShowInviteModal(false)} />
                    :
                    null
            }
        </Fragment>
    )
};

export default InvestmentSummaryCard;